/**
 * Les routes poussées du lot Messagerie : celles qu'il fait passer sur le design system.
 *
 * `messenger` : la conversation avec un tuteur (`StudentTutorConversationScreen`). Elle rend
 * l'écran des ports pour un élève dont l'espace est allumé, hors espace parent et hors live, et
 * son écran legacy ailleurs (le tuteur, le parent, l'élève éteint).
 *
 * L'écran n'est chargé qu'à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../loadedOnRender"
import { type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

export const messagingRoutes: StudentSpaceRouteTable<"messaging"> = {
    messenger: loadedOnRender(
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        () => require("./StudentTutorConversationScreen").StudentTutorConversationScreen,
        "StudentTutorConversationScreen"
    ),
}
